/* Small flags kept on the device: has this person seen the welcome, have we already
   asked about the home screen, and when did we last say hello. Storage can throw in a
   private window, so every read answers false rather than breaking the screen. */

const KEYS = {
  welcome: "hottip.welcome",
  install: "hottip.install",
} as const;

export type SeenKey = keyof typeof KEYS;

const GREETED = "hottip.greeted";

export const seen = {
  has(key: SeenKey) {
    try {
      return localStorage.getItem(KEYS[key]) === "1";
    } catch {
      return false;
    }
  },
  set(key: SeenKey) {
    try {
      localStorage.setItem(KEYS[key], "1");
    } catch {
      // A device that will not remember is a device that sees the welcome twice. Fine.
    }
    // The door check runs on the server, which cannot read localStorage, so the welcome
    // flag is mirrored into a cookie. A year is longer than anyone needs the pitch twice.
    if (key === "welcome") {
      try {
        document.cookie = `${KEYS.welcome}=1; path=/; max-age=31536000; samesite=lax`;
      } catch {
        // Same story: an extra look at the welcome, nothing broken.
      }
    }
  },
};

/* The greeting is a nice thing once a day and a toll booth every launch, so it is keyed
   to the San Diego date rather than a timestamp. Same day, no second hello. */
export function sdToday() {
  return new Date().toLocaleDateString("en-CA", { timeZone: "America/Los_Angeles" });
}

export const greeting = {
  due() {
    try {
      return localStorage.getItem(GREETED) !== sdToday();
    } catch {
      return false;
    }
  },
  done() {
    try {
      localStorage.setItem(GREETED, sdToday());
    } catch {
      // Not remembering means one extra hello. Harmless.
    }
  },
};
